import React,{ useState,useEffect } from 'react'
import {
    Card,
    CardBody,
    Row,
    Col,
    Input,
    FormGroup,
    UncontrolledTooltip,
    Button,
    
  } from "reactstrap";
  import Select from "react-select";
  import { MDBInput } from "mdb-react-ui-kit";
  import NotificationAlert from "react-notification-alert";
  import {BASE_URL_CHAT_APP,SMS_TMPLTS_SNDRIDS,WHATSAPP_INSTANT,WHATSAPP_TEMPLATE,ALL_META_TEMPLATES,CHANNEL_CLIENT_CHNLTYPE} from "../../constants"
  import axios from "axios";
  import apiService from '../../variables/apiService';


  let userObj = localStorage.getItem("user");
  let user = JSON.parse(userObj);
  let initialvalues= {
    phoneNum:"",
    senderid:"",
    templateid:"",

  }
  let category = [
    {
      value: "",
      label: "Select Category",
      isDisabled: true,
    },
    { value: "Marketing", label: "Marketing" },
    { value: "Utility", label: "Utility" },
    { value: "Authentication", label: "Authentication" },
    { value: "Service", label: "Service" },
  
  ];
  let categoryNum = [
    {
      value: "",
      label: "Select Category",
      isDisabled: true,
    },
    { value: 1, label: "Marketing" },
    { value: 2, label: "Utility" },
    { value: 3, label: "Authentication" },
    { value: 4, label: "Service" },
  
  ];

  let templates = [];
  let senderids = [];
const InstantWhatsapp = () => {
  const [whtasppdata,setWhatsappdata] = useState(initialvalues)
  const [channel, setChannel] = useState([]);
  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorhandle,setErrorHandle]= useState()
  useEffect(()=>{
    fetchChanelsbyClient();
 
  },[])
  


  // const fetchChanelsbyClient=async()=>{
  //   setIsLoading(true)

  //   const payload={
  
  //     clientid:user?.client
  //   }
  //   user?.client!=0&&(await axios.post(ALL_META_TEMPLATES,payload).then(res=>{
    
  //     if(res?.data){
  //       setWhatsappdata(res?.data?.message)
  //       setChannel(res?.data?.message)
  //     templates=[]
  //     res?.data?.message?.map((wtsap,i)=>{
  //       wtsap?.name&&templates.push({ value:wtsap?.name, label: wtsap?.name })
        
  //     })


   
  //   }
  //     setIsLoading(false)
  //    }).catch(e=>{
     
  //     let options = {};
  //         options = {
  //           place: "tr",
  //           message: "Template Not Found",
  //           type: "warning",
  //           autoDismiss: 2,
  //         };
  //         notificationAlertRef?.current?.notificationAlert(options);
  //   }))
  //   setIsLoading(false)
  // }

  const fetchChanelsbyClient=async()=>{
    setIsLoading(true)

    const payload={
      channels_type:"whatsapp",
      clintId:user?.client
    }
    user?.client!=0&&(await axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      if(res?.data){
      templates=[]
      
     
      
      //setWhatsappCampaign(res?.data)
      setChannel(res?.data)

      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template })
       
     })
    }
      setIsLoading(false)
     }).catch(e=>{
     
      let options = {};
          options = {
            place: "tr",
            message: e.code,
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    }))

  }

  const changeSender=(data)=>{
    senderids=[]
    
      const chnl=channel.filter(item=>item.template==data.value)
     //const chnl=channel.filter(item=>item.name==data.value)
     let catgry =[]
     catgry= category?.filter(item=>item.value?.toLowerCase()==chnl[0]?.category?.toLowerCase())
 
      if(catgry.length==0){
        catgry= categoryNum?.filter(item=>item.value==chnl[0]?.category)
      }
      if(catgry[0]){
        setWhatsappdata({...whtasppdata,category:catgry[0]})
      }else{
        setWhatsappdata({...whtasppdata,category:{ value: "", label: "Select" }})
      }
      const senderid = chnl[0]?.senderid?.split(",");
          for(let i=0;i<senderid?.length;i++){
            senderids.push({label:senderid[i],value:senderid[i]})
          }
    setWhatsappdata(prev=>({...prev,templateid:data,senderid:""}))
  }

  // const changeSender=(data)=>{
  //   senderids=[]
   
  //   const chnl=channel.filter(item=>item.name==data.value)
  
  //  // let catgry = category?.filter(item=>item.value===chnl[0]?.category)
 
  //   if(chnl[0]?.category){
      
    
  //     setWhatsappdata({...whtasppdata,category:{ value: chnl[0]?.category, label: chnl[0]?.category }})
  //   }else{
  //     setWhatsappdata({...whtasppdata,category:{ value: "", label: "Select" }})
  //   }

  //   const senderid = chnl[0]?.senderid?.split(",");
  //       for(let i=0;i<senderid?.length;i++){
  //         senderids.push({label:senderid[i],value:senderid[i]})
  //       }
      
  //       setWhatsappdata(prev=>({...prev,templateid:data,senderid:{label:user.sender_id,value:user.sender_id},message: chnl[0]?.components}))
  //       setIsLoading(false)
  // }
  const submitFields= async()=>{
    const isValid = validate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){

    
    let payload={
      tname:whtasppdata?.templateid.value,
      senderid:whtasppdata?.senderid.value,
      msisdn:`91${whtasppdata.phoneNum}`
    }
    setIsLoading(true)
    await  apiService.postData(WHATSAPP_INSTANT,payload).then(res=>{
      let options = {};
      options = {
        place: "tr",
        message: "Sent Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
      setWhatsappdata(initialvalues)
    
      }).catch(err=>{
        {
          let options = {};
          options = {
            place: "tr",
            message: "Backend Error",
            type: "warning",
    
            autoDismiss: 2,
          };
          notificationAlertRef.current.notificationAlert(options);
        }
      })
      setIsLoading(false)
    }
   }

   const validate=()=>{
   const num = whtasppdata?.phoneNum?.split("")[0];
    let errors={}
    if(!whtasppdata.phoneNum){
      errors.phoneNum="Please Enter Phone Number"
    } else if(whtasppdata?.phoneNum?.length!=10){
      errors.phoneNum="Please Enter 10 Digits"
    }else if(num<=5||num=="-"||num=="+"||num=="e"){
      errors.phoneNum=`Number should not starts with ${num}`
    }
    if(!whtasppdata?.templateid?.value){
      errors.templateid="Please Select Template"
    }
    if(!whtasppdata?.senderid?.value){
      errors.senderid="Please Select Sender Id"
    }
    return errors;
   }
  return (
    <div className='content'>
        <Card>
            <CardBody>
            <NotificationAlert ref={notificationAlertRef} />
            <Row className="mb-4 ">
            <Col md="3" sm="12" >
              <label>Mobile No <suf style={{color:"red"}}>*</suf> </label>
            <FormGroup>
              <Input  type="number" placeholder="Mobile Number" maxLength={10} value={whtasppdata.phoneNum} name="mobileno"   onChange={(e)=>{ setWhatsappdata({
                        ...whtasppdata,
                        phoneNum: e.target.value,
                      });}} />
            </FormGroup>

                      <span style={{color:"red"}}>{errorhandle?.phoneNum}</span>
        </Col>
        
   
                  <Col md="3" sm="12">
          <label>Select Template<suf style={{color:"red"}}>*</suf> </label>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="templateSelect"
            value={whtasppdata.templateid}
            onChange={(value) => changeSender(value)}
            options={templates}
            placeholder="Select"
          />
          {errorhandle?.templateid&&<span style={{color:"red"}}>{errorhandle?.templateid}</span>}
        </Col>
      
        <Col md="2" sm='12'>
                    <label>Category</label>
                    <FormGroup>
                      <Input type="Text" readOnly={true} value={whtasppdata?.category?.label}  />
                    </FormGroup>
                   
                  </Col>
        <Col md="2" sm="12">
          <p className="category">Select Sender</p>
          <Select
            className="react-select info"
            classNamePrefix="react-select"
            name="senderSelect"
            value={whtasppdata?.senderid}
            onChange={(value) => setWhatsappdata(prev=>({...prev,senderid:value}))}
            options={senderids}
            placeholder="Select"
          />
           {errorhandle?.senderid&&<span style={{color:"red"}}>{errorhandle?.senderid}</span>}
        </Col> 
             
           
            <Col md="2" sm="3">
                <Button
                  color="primary "
                  disabled={isLoading}
                  className="mt-4 btn btn-icon animation-on-hover"
                  id="tooltipsubmit"
                  type="button"
                  onClick={() => submitFields()}
                >
                  <i className="tim-icons icon-double-right" />
                </Button>
                
              </Col>
            </Row>
            </CardBody>
        </Card>
    </div>
  )
}

export default InstantWhatsapp
